export const firstPageComponent = (role: string) => {
  let path: string;
  switch (role) {
    case 'WAREHOUSE_OPERATOR':
      path = '/parcels-warehouse-operator';
      break;
    case 'PARTNER_ADMIN':
      path = '/orders';
      break;
    case 'WAREHOUSE_ADMIN':
      path = '/warehouse-admin-orders';
      break;
    case 'LOGISTICS_ADMIN':
      path = '/nonPost-orders';
      break;
    case 'SELLER_ADMIN':
      path = '/seller-orders';
      break;
    case 'FINANCIAL_ADMIN':
      path = '/invoice'
      break;
    case 'EXCHANGE_ADMIN':
      path = '/bundles'
      break;
    default:
      path = '/orders';
  }
  return path;
};
